
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/todo-app",
      function () {
        return require("private-next-pages/examples/todo-app.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/todo-app"])
      });
    }
  